// Copyright 2021
//   __  __                       _           _     _   _            _ _   _
//  |  \/  | ___   ___  _ __  ___| |__   ___ | |_  | | | | ___  __ _| | |_| |__
//  | |\/| |/ _ \ / _ \| '_ \/ __| '_ \ / _ \| __| | |_| |/ _ \/ _` | | __| '_ \
//  | |  | | (_) | (_) | | | \__ \ | | | (_) | |_  |  _  |  __/ (_| | | |_| | | |
//  |_|  |_|\___/ \___/|_| |_|___/_| |_|\___/ \__| |_| |_|\___|\__,_|_|\__|_| |_|
//
//  All Rights Reserved.
//
// NOTICE:  All information contained herein is, and remains
// the property of Moonshot Health Incorporated and its suppliers,
// if any.  The intellectual and technical concepts contained
// herein are proprietary to Adobe Systems Incorporated
// and its suppliers and may be covered by U.S. and Foreign Patents,
// patents in process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Moonshot Health Incorporated.

// @generated by protoc-gen-connect-web v0.11.0 with parameter "target=js,import_extension=none"
// @generated from file msh/service/v1/alert_manager.proto (package msh.service.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { AcknowledgeAlertByUserRequest, AcknowledgeAlertByUserResponse, AcknowledgeAlertRequest, AcknowledgeAlertResponse, AcknowledgeConsumerAlertRequest, AcknowledgeConsumerAlertResponse, ConfirmAlertRequest, ConfirmAlertResponse, GetAlertByEventRequest, GetAlertByEventResponse, GetAlertRequest, GetAlertResponse, GetAlertsRequest, GetAlertsResponse, IncreaseAlertLevelRequest, IncreaseAlertLevelResponse, ProcessAlertRequest, ProcessAlertResponse, ProcessWanderingRequest, ProcessWanderingResponse, SendAlertRequest, SendAlertResponse } from "./alert_manager_pb";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * This interface is used only by the backend. It should never be used by users.
 * Intead, the rpc on the device resource shoud be used.
 *
 * @generated from service msh.service.v1.AlertManager
 */
export const AlertManager = {
  typeName: "msh.service.v1.AlertManager",
  methods: {
    /**
     * @generated from rpc msh.service.v1.AlertManager.SendAlert
     */
    sendAlert: {
      name: "SendAlert",
      I: SendAlertRequest,
      O: SendAlertResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc msh.service.v1.AlertManager.ProcessAlert
     */
    processAlert: {
      name: "ProcessAlert",
      I: ProcessAlertRequest,
      O: ProcessAlertResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc msh.service.v1.AlertManager.ConfirmAlert
     */
    confirmAlert: {
      name: "ConfirmAlert",
      I: ConfirmAlertRequest,
      O: ConfirmAlertResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc msh.service.v1.AlertManager.AcknowledgeAlert
     */
    acknowledgeAlert: {
      name: "AcknowledgeAlert",
      I: AcknowledgeAlertRequest,
      O: AcknowledgeAlertResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc msh.service.v1.AlertManager.AcknowledgeConsumerAlert
     */
    acknowledgeConsumerAlert: {
      name: "AcknowledgeConsumerAlert",
      I: AcknowledgeConsumerAlertRequest,
      O: AcknowledgeConsumerAlertResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc msh.service.v1.AlertManager.IncreaseAlertLevel
     */
    increaseAlertLevel: {
      name: "IncreaseAlertLevel",
      I: IncreaseAlertLevelRequest,
      O: IncreaseAlertLevelResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc msh.service.v1.AlertManager.GetAlerts
     */
    getAlerts: {
      name: "GetAlerts",
      I: GetAlertsRequest,
      O: GetAlertsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc msh.service.v1.AlertManager.GetAlert
     */
    getAlert: {
      name: "GetAlert",
      I: GetAlertRequest,
      O: GetAlertResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc msh.service.v1.AlertManager.GetAlertByEvent
     */
    getAlertByEvent: {
      name: "GetAlertByEvent",
      I: GetAlertByEventRequest,
      O: GetAlertByEventResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc msh.service.v1.AlertManager.AcknowledgeAlertByUser
     */
    acknowledgeAlertByUser: {
      name: "AcknowledgeAlertByUser",
      I: AcknowledgeAlertByUserRequest,
      O: AcknowledgeAlertByUserResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc msh.service.v1.AlertManager.ProcessWandering
     */
    processWandering: {
      name: "ProcessWandering",
      I: ProcessWanderingRequest,
      O: ProcessWanderingResponse,
      kind: MethodKind.Unary,
    },
  }
};

